import * as React from 'react';
import { Props } from 'react';

import './RegistrationAuthorization.scss';
import i18next from 'i18next';
import Spiner from './Spiner/Spiner';

interface SendCodeViewProps extends Props<SendCodeView> {
    name: string;
    code: string;
    error: string;
    channelId: string;
    setCode: (code: string) => any;
    onSendCode: (code: string) => any;
    codeLength: number;
    loading?: boolean;
    isFirebaseAuth: boolean;
}

interface SendCodeViewState {
    isShowError: boolean;
}

export class SendCodeView extends React.Component<SendCodeViewProps, SendCodeViewState> {
    timer: NodeJS.Timer;

    state = {
        isShowError: false,
    };

    showError = () => {
        this.setState({
            isShowError: true,
        }, () => {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            setTimeout(() => this.setState({
                isShowError: false
            }), 5000);
        });
    }

    componentDidMount() {
        const {error} = this.props;
        if (error) {
            this.showError();
        }
    }

    componentWillReceiveProps(next: SendCodeViewProps) {
        if (next.error && (next.error !== this.props.error)) {
            this.showError();
        }
        if (!next.error && (next.error !== this.props.error)) {
            this.setState({isShowError: false});
        }
    }

    onSetCode = (code: string) => {
        const {setCode, onSendCode, codeLength} = this.props;
        setCode(code);
        if (code.length === codeLength) {
            onSendCode(code);
        }   
    }

    render() {
        const {code, name, error, channelId, codeLength, loading, isFirebaseAuth} = this.props;
        const {isShowError} = this.state;
        return (
            <div className={`authorization-container ${channelId}`}>
                {isFirebaseAuth ? <div id='recaptcha-container' /> : null}
                {loading ? <Spiner channelId={channelId} />
                    : <div className={`authorization ${channelId}`}>
                        <div className={`auth-tab ${channelId}`}>
                            <div className={`auth-title auth-title-${channelId}`}>
                                {name}
                            </div>
                        </div>
                        <div className='auth-message'>
                            <div className={`auth-error ${isShowError ? 'show' : ''}`} dangerouslySetInnerHTML={{__html: error}} />
                        </div>
                        <div className='auth-body'>
                            <div className='auth-body-title'>
                                {i18next.t('input_your_sms_code')}
                            </div>
                            <div className='auth-body-code'>
                                <input
                                    autoComplete='off'
                                    autoFocus={true}
                                    type='tel'
                                    name='code'
                                    value={''}
                                    onKeyDown={(e) => e.keyCode === 8 || e.keyCode === 46 ? this.onSetCode(code.slice(0, code.length - 1)) : {}}
                                    onChange={(e) => (code.length < codeLength) ? this.onSetCode(code + e.target.value) : {}}
                                />
                                <div className='auth-body-input'>
                                    {new Array(codeLength).fill(0).map((v, i) => {
                                        return (
                                            <span key={i} className={`${i < code.length ? 'black' : ''}`} />
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationAuthorization/SendCodeView.tsx